'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _logValues = require('../../../shared/logging/log-values');

var _Uniform = require('../../Uniform');

require('../../../css/_follow-user.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var FollowUserButton = function (_PureComponent) {
  _inherits(FollowUserButton, _PureComponent);

  function FollowUserButton() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, FollowUserButton);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = FollowUserButton.__proto__ || Object.getPrototypeOf(FollowUserButton)).call.apply(_ref, [this].concat(args))), _this), _this._followClicked = function () {
      _this.props.followUser(_this.props.feedUserId.type, _this.props.feedUserId.relatedId, _this.props.logData);
    }, _this._unfollowClicked = function () {
      _this.props.unfollowUser(_this.props.feedUserId.type, _this.props.feedUserId.relatedId, _this.props.logData);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(FollowUserButton, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (typeof this.props.isFollowing === 'undefined') {
        this.props.getIsFollowing(this.props.feedUserId.type, this.props.feedUserId.relatedId);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var isFollowing = this.props.isFollowing;

      return _react2.default.createElement(
        'div',
        { className: 'follow-feeduser' },
        _react2.default.createElement(
          _Uniform.Button,
          {
            size: 'xsmall',
            type: isFollowing ? 'confirm' : 'subtle',
            icon: isFollowing ? _react2.default.createElement(_Uniform.Icon, { type: 'confirmation' }) : null,
            onClick: isFollowing ? this._unfollowClicked : this._followClicked
          },
          isFollowing ? 'Following' : 'Follow'
        )
      );
    }
  }]);

  return FollowUserButton;
}(_react.PureComponent);

FollowUserButton.propTypes = {
  feedUserId: _react2.default.PropTypes.shape({
    type: _react2.default.PropTypes.number.isRequired,
    relatedId: _react2.default.PropTypes.string.isRequired
  }).isRequired,
  isFollowing: _react2.default.PropTypes.bool,
  getIsFollowing: _react2.default.PropTypes.func.isRequired,
  followUser: _react2.default.PropTypes.func.isRequired,
  unfollowUser: _react2.default.PropTypes.func.isRequired,
  logData: _react2.default.PropTypes.object
};
FollowUserButton.defaultProps = {
  logData: {
    App: _logValues.WEB_APP,
    Origin: 'Feed'
  }
};
exports.default = FollowUserButton;